module.exports = __webpack_public_path__ + "static/ribeye.c7582c34.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ribeye.png
// module id = 902
// module chunks = 265272396218350